var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H6.5C5.39543 0 4.5 0.89543 4.5 2C3.39543 2 2.5 2.89543 2.5 4V14C2.5 15.1046 3.39543 16 4.5 16H11.5C12.6046 16 13.5 15.1046 13.5 14C14.6046 14 15.5 13.1046 15.5 12V2C15.5 0.89543 14.6046 0 13.5 0ZM13.5 13V4C13.5 2.89543 12.6046 2 11.5 2H5.5C5.5 1.44772 5.94772 1 6.5 1H13.5C14.0523 1 14.5 1.44772 14.5 2V12C14.5 12.5523 14.0523 13 13.5 13ZM3.5 4C3.5 3.44772 3.94772 3 4.5 3H11.5C12.0523 3 12.5 3.44772 12.5 4V14C12.5 14.5523 12.0523 15 11.5 15H4.5C3.94772 15 3.5 14.5523 3.5 14V4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.55272456a1e81ebc64746ad32e10ae9a.svg";
export { ForwardRef as ReactComponent };